import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Description from "@components/CustomTypography/Description/Description"
import NewResponsiveImage from "@components/CustomTypography/NewResponsiveImage/NewResponsiveImage"
import Separator from "@components/CustomTypography/Separator/Separator"
import Title from "@components/CustomTypography/Title/Title"
import {AdvancedSideAssetModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./IntroductionSection.module.scss"

type Props = {
	data: AdvancedSideAssetModuleType
}

const IntroductionSection = (props: Props) => {
	return (
		<ContainerWrapper>
			<Separator size={128} />
			<div className={styles.container}>
				<div>
					<Title
						content={props.data.mainContent?.[0].title}
						fontWeight={600}
						size={"L"}
					/>
					<Description
						className={styles.description}
						content={props.data.mainContent?.[0].content}
						size={"L"}
					/>
				</div>

				{props.data.mainContent?.[0].preview && (
					<NewResponsiveImage
						containerClassName={styles.imageContainer}
						{...props.data.mainContent?.[0].preview}
					/>
				)}
			</div>

			<Separator size={128} />
		</ContainerWrapper>
	)
}

export default IntroductionSection
